const NAVBAR_MOBILE_EXCLUDED_PAGES = ["/pages/put_money_on_account/"];

// Правила отображения NavBarMobile
// Можно расширять другими правилами в будущем
// Сейчас для SSR будет возвращать true, так как нет pathname
export const getIsEnabledShowNavBarMobile = (pathname = "") => {
  return !NAVBAR_MOBILE_EXCLUDED_PAGES.includes(pathname);
};
